
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 15V4a1 1 0 00-.38-.78 1 1 0 00-.84-.2l-9 2A1 1 0 008 6v8.34a3.49 3.49 0 102 3.18c.01-.173.01-.347 0-.52V6.8l7-1.55v7.09a3.49 3.49 0 102 3.17c.01-.17.01-.34 0-.51zM6.54 19A1.49 1.49 0 118 17.21c.01.1.01.2 0 .3A1.49 1.49 0 016.54 19zm9-2A1.5 1.5 0 1117 15.21c.01.1.01.2 0 .3A1.5 1.5 0 0115.51 17h.03z"}})])
          )
        }
      }
    